var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "font-montserrat antialiased font-normal text-base text-gray-900 leading-tight bg-gray-100 max-h-screen"
    },
    [
      _vm.ready
        ? _c(
            "div",
            { staticClass: "flex flex-col min-h-screen" },
            [
              _vm.$media.loaded && !_vm.$ui.headerHidden
                ? _c("AppHeader")
                : _vm._e(),
              _c(
                "main",
                {
                  staticClass:
                    "flex flex-col flex-grow mx-auto max-w-content w-full px-4"
                },
                [
                  _vm.$app.isCrashed
                    ? _c("CrashReport")
                    : !_vm.$auth.refreshing
                    ? _c("router-view")
                    : _vm._e()
                ],
                1
              ),
              _c("AppFooter")
            ],
            1
          )
        : _vm._e(),
      _c("AppOverlay"),
      _c("AppModals"),
      _c("AppSnackbars"),
      _c("input", {
        ref: "file-picker",
        staticClass: "fixed left-full",
        attrs: { id: "file-picker", type: "file" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }